import Tooltip from "rc-tooltip";
import React from "react";

import FormattedMessage from "@components/UI/FormattedMessage";

export const LowCostIndicator = () => {
  return (
    <Tooltip
      placement="bottomRight"
      trigger={["hover", "click"]}
      overlay={
        <span>
          <FormattedMessage id="FlightOffer.LowCostIndicator.tooltip" />
        </span>
      }
      overlayClassName="brands-table-service-name-tooltip"
    >
      <span style={{ fontSize: "11pt" }}>LCC</span>
    </Tooltip>
  );
};
